const loadPrivacyTerms = e => {
  const holder = cube.$('.privacy-infos__holder');
  const contextKeyword = cube.$('#gift-card') ? 'GiftCard' : 'BackInStock';
  if (e.target.checked) {
    if (holder.classList.contains('privacy-infos__holder--loading')) {
      cube
        .cartridge('privacy-rules')
        .after(() => {
          holder.classList.remove('privacy-infos__holder--loading');
        })
        .reload({ context: contextKeyword });
    }
    cube.$id('main-container').style.zIndex = 'inherit';
  } else cube.$id('main-container').style.zIndex = null;
};

export const init = () => {
  const modalTogglerInput = cube.$id('privacy-infos-modal__chk');
  modalTogglerInput.addEventListener('change', loadPrivacyTerms);
};



// WEBPACK FOOTER //
// ./src/catalog/product-details/privacy-infos.js